/* ChewNectar box builder v9. Tiers (2 = 15%, 3-4 = 20%, 5 = 25%), a progress meter that fills as jars are added,
   and stage-by-stage messages. The discount itself is applied at checkout by matching automatic discounts. */
(() => {
  const fmt = (c) => {
    const whole = Math.round(c) % 100 === 0;
    return '\u20B9' + (c / 100).toLocaleString('en-IN', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
  };
  const ORD = ['', 'first', 'second', 'third', 'fourth', 'fifth', 'sixth'];
  const build = (root) => {
    const tiers = JSON.parse(root.dataset.tiers || '[]').sort((a, b) => a.qty - b.qty);
    const maxQty = Number(root.dataset.max) || (tiers.length ? tiers[tiers.length - 1].qty : 5);
    const picks = new Map();
    const q = (s) => root.querySelector(s);
    const slots = q('[data-cb9-slots]'), bar = q('[data-cb9-bar]'), subEl = q('[data-cb9-sub]');
    const saveRow = q('[data-cb9-saverow]'), saveEl = q('[data-cb9-save]'), wasEl = q('[data-cb9-was]');
    const totEl = q('[data-cb9-total]'), nextEl = q('[data-cb9-next]'), addBtn = q('[data-cb9-add]'), done = q('[data-cb9-complete]');
    const plusBtns = [...root.querySelectorAll('[data-cb9-plus]')];
    const minUnit = Math.min(...plusBtns.map((b) => Number(b.dataset.price)));
    const count = () => [...picks.values()].reduce((n, p) => n + p.qty, 0);
    const subtotal = () => [...picks.values()].reduce((n, p) => n + p.qty * p.price, 0);
    const pct = (n) => { let p = 0; tiers.forEach((t) => { if (n >= t.qty) p = t.pct; }); return p; };
    const priceFor = (n, sub) => Math.round((sub * (100 - pct(n))) / 100);

    const message = (n, sub, total, saved) => {
      if (!n) return nextEl.dataset.empty || '';
      if (n >= maxQty) return 'You\u2019ve unlocked ' + pct(n) + '% off, saving ' + fmt(saved) + '.';
      if (n === maxQty - 1) return 'Complete your bundle: add the ' + ORD[maxQty] + ' for just ' + fmt(priceFor(n + 1, sub + minUnit) - total) + ' more.';
      const nx = tiers.find((t) => t.qty > n);
      if (!nx) return '';
      const need = nx.qty - n;
      return 'Add ' + need + ' more product' + (need > 1 ? 's' : '') + ' to unlock ' + nx.pct + '% off.';
    };

    const render = () => {
      const n = count(), sub = subtotal(), total = priceFor(n, sub), saved = Math.max(0, sub - total);
      root.querySelectorAll('[data-tier-q]').forEach((el) => {
        const tq = Number(el.dataset.tierQ);
        const next = tiers.find((t) => t.qty > tq);
        el.classList.toggle('is-on', n >= tq && (!next || n < next.qty));
        el.classList.toggle('is-done', n >= tq);
      });
      root.querySelectorAll('[data-step]').forEach((li) => {
        const s = Number(li.dataset.step);
        li.classList.toggle('is-done', n >= s);
        const lab = li.querySelector('[data-step-label]');
        if (lab) lab.textContent = pct(s) ? pct(s) + '% off' : 'Start';
      });
      if (bar) bar.style.width = (Math.max(0, Math.min(n, maxQty) - 1) / (maxQty - 1)) * 100 + '%';
      if (slots) {
        const flat = [];
        picks.forEach((pk) => { for (let i = 0; i < pk.qty; i += 1) flat.push(pk); });
        [...slots.children].forEach((li, i) => {
          const pk = flat[i];
          li.classList.toggle('is-full', !!pk);
          li.style.setProperty('--sc', pk ? pk.color : '');
          li.style.setProperty('--sc2', pk ? pk.color2 : '');
          li.innerHTML = pk && pk.img ? '<img src="' + pk.img + '" alt="" loading="lazy">' : (li.dataset.label || '');
        });
      }
      if (subEl) subEl.textContent = fmt(sub);
      if (totEl) totEl.textContent = fmt(total);
      if (wasEl) wasEl.textContent = saved > 0 ? fmt(sub) : '';
      if (saveRow) saveRow.hidden = saved <= 0;
      if (saveEl) saveEl.textContent = fmt(saved);
      if (nextEl) { nextEl.textContent = message(n, sub, total, saved); nextEl.hidden = !nextEl.textContent; nextEl.classList.toggle('is-win', n >= maxQty); }
      if (done) done.hidden = !(n === maxQty && picks.size === plusBtns.length);
      if (addBtn) addBtn.disabled = n === 0;
      plusBtns.forEach((b) => { b.disabled = n >= maxQty; });
    };

    const change = (btn, delta) => {
      const id = btn.dataset.id;
      const cur = picks.get(id);
      if (delta > 0 && count() >= maxQty) return;
      if (!cur && delta > 0) picks.set(id, { qty: 1, price: Number(btn.dataset.price), img: btn.dataset.img, color: btn.dataset.color, color2: btn.dataset.color2 });
      else if (cur) { cur.qty += delta; if (cur.qty <= 0) picks.delete(id); }
      const out = root.querySelector('[data-cb9-out="' + id + '"]');
      if (out) out.textContent = picks.has(id) ? picks.get(id).qty : 0;
      const card = btn.closest('[data-cb-card]');
      if (card) card.classList.toggle('is-in', picks.has(id));
      render();
    };
    plusBtns.forEach((b) => b.addEventListener('click', () => change(b, 1)));
    root.querySelectorAll('[data-cb9-minus]').forEach((b) => b.addEventListener('click', () => change(b, -1)));
    if (addBtn) {
      addBtn.addEventListener('click', async () => {
        const items = [...picks.entries()].map(([id, p]) => ({ id: Number(id), quantity: p.qty }));
        if (!items.length) return;
        addBtn.setAttribute('aria-busy', 'true');
        try {
          if (window.cnAddToCart) await window.cnAddToCart(items);
          else { await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) }); window.location.href = '/cart'; }
        } finally { addBtn.removeAttribute('aria-busy'); }
      });
    }
    render();
  };
  const start = () => document.querySelectorAll('[data-cb9]').forEach((el) => {
    if (el.dataset.cb9Ready) return;
    el.dataset.cb9Ready = '1';
    build(el);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();